const messages = {
  subtitle: "Meet Our Bridgestone team",
  title: "Contact service",
  description: "Welcome to contact service",
  teams: {
    direct: "Direct",
    indirect: "In Direct",
    tyre: "Gumiabroncs-kereskedelmi csapat",
    car: "Autókereskedői csapat",
    lkw: "Tehergépkocsi csapat",
    em_otr: "EM/OTR csapat",
    farm_tractor: "Mezőgazdasági traktor csapat",
    bandag: "Bandag csapat",
    subtitle: "Meet Our Bridgestone team",
  },
  contact: {
    index: {
      title: "",
      description: "",
    },
    categories: {
      service: {
        description: "",
      },
      touch: {
        title: "",
        description: "",
      },
      contact: {
        short_desc: "",
      },
    },
    strategicPartners: {
      cardTitle: "",
      short_desc: "",
    },
  },
};

export default {
  messages,
};
